export { default } from './SkeletonFaresCarouselBackgroundImage';
